import _ from 'underscore';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Row, Col, Button, Label } from 'reactstrap';
import { removeItemWithConfirm } from '../common/classes/handleItemWithConfirm';
import entityComposition from '../common/classes/entityComposition';
import DateTimePicker from '../common/controls/dateTimePicker';
import SinglePicker from '../common/controls/singlePicker';
import NumberInput from '../common/controls/numberInput';
import Icon from '../common/containers/icon';
const getObjectDiff = function getObjectDiff() {
  let objectA = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let objectB = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return _.reduce(objectA, (result, value, key) => _.isEqual(value, objectB[key]) ? result : result.concat(key), []);
};
const confirmOnRemoveFields = ['dateAndTime', 'assetCoatingFinishID', 'assetCoatingAdhesionID', 'percentFailure', 'dft', 'conditionScore'];
class AssetDetailsConditionItem extends Component {
  constructor(props) {
    super(props);
    this.getConditionScore = this.getConditionScore.bind(this);
  }
  componentDidMount() {
    const _this$props = this.props,
      assetCoatingFinish = _this$props.assetCoatingFinish,
      assetCoatingFinishActions = _this$props.assetCoatingFinishActions,
      assetCoatingAdhesion = _this$props.assetCoatingAdhesion,
      assetCoatingAdhesionActions = _this$props.assetCoatingAdhesionActions;
    assetCoatingFinishActions.serverIndex(assetCoatingFinish.indexQuery);
    assetCoatingAdhesionActions.serverIndex(assetCoatingAdhesion.indexQuery);
  }

  // Only update the condition score if one of the 4 fields are changed
  componentDidUpdate(_ref) {
    let previousCondition = _ref.condition;
    const newCondition = this.props.condition;
    // order matters here because newCondition may have keys that are not present in prevCondition
    const conditionDiff = getObjectDiff(newCondition, previousCondition);
    if (conditionDiff.length && (conditionDiff.includes('percentFailure') || conditionDiff.includes('dft') || conditionDiff.includes('assetCoatingFinishID') || conditionDiff.includes('assetCoatingAdhesionID'))) {
      this.getConditionScore();
    }
  }
  getConditionScore() {
    const _this$props2 = this.props,
      coatingDFTFactorOutsideLimits = _this$props2.coatingDFTFactorOutsideLimits,
      conditionIndex = _this$props2.conditionIndex,
      onChange = _this$props2.onChange,
      _this$props2$conditio = _this$props2.condition,
      assetCoatingAdhesionID = _this$props2$conditio.assetCoatingAdhesionID,
      assetCoatingFinishID = _this$props2$conditio.assetCoatingFinishID,
      percentFailure = _this$props2$conditio.percentFailure,
      dft = _this$props2$conditio.dft,
      conditionScore = _this$props2$conditio.conditionScore,
      coatingDFTToleranceLow = _this$props2.coatingDFTToleranceLow,
      coatingDFTToleranceHigh = _this$props2.coatingDFTToleranceHigh,
      coatingDFTFactorWithinLimits = _this$props2.coatingDFTFactorWithinLimits,
      acaList = _this$props2.assetCoatingAdhesion.list,
      acfList = _this$props2.assetCoatingFinish.list;
    const assetCoatingAdhesion = acaList.filter(next => next.id === assetCoatingAdhesionID)[0];
    const assetCoatingFinish = acfList.filter(next => next.id === assetCoatingFinishID)[0];
    let score = null;
    if (assetCoatingAdhesion && assetCoatingFinish && typeof percentFailure !== 'undefined' && percentFailure !== null && typeof dft !== 'undefined' && dft !== null) {
      // Set the DFT Factor
      const dftFactor = dft >= coatingDFTToleranceLow && dft <= coatingDFTToleranceHigh ? coatingDFTFactorWithinLimits : coatingDFTFactorOutsideLimits;

      // Adjust the finish factor if needed
      const finish = assetCoatingFinish.identifier === 'gloss' || assetCoatingFinish.identifier === 'rustAndPitting' ? 1.0 : 0.9;

      // Calculate the score! The parseInt() drops off the decimal without
      // rounding, ie. parseInt(12.9999) === 12
      score = parseInt(assetCoatingAdhesion.identifier * (100 - percentFailure) * finish * dftFactor, 10);

      // only update state if the score has changed
      if (conditionScore !== score) {
        onChange(conditionIndex, 'conditionScore', score);
      }
    } else if (!_.isNull(conditionScore)) {
      // clear condition score if the other inputs are changed
      onChange(conditionIndex, 'conditionScore', null);
    }
  }
  render() {
    const _this$props3 = this.props,
      onRemove = _this$props3.onRemove,
      conditionIndex = _this$props3.conditionIndex,
      condition = _this$props3.condition,
      onChange = _this$props3.onChange,
      assetCoatingAdhesion = _this$props3.assetCoatingAdhesion,
      assetCoatingFinish = _this$props3.assetCoatingFinish;
    const percentFailure = condition.percentFailure,
      dateAndTime = condition.dateAndTime,
      assetCoatingFinishID = condition.assetCoatingFinishID,
      assetCoatingAdhesionID = condition.assetCoatingAdhesionID,
      dft = condition.dft,
      conditionScore = condition.conditionScore;
    const handleChange = (key, value) => onChange(conditionIndex, key, value);
    const handleChangeDft = value => handleChange('dft', value);
    const handleChangeAssetCoatingAdhesion = value => handleChange('assetCoatingAdhesionID', value);
    const handleChangeConditionAssetCoatingFinish = value => handleChange('assetCoatingFinishID', value);
    const handleChangePercentFailure = value => handleChange('percentFailure', value || value === 0 ? parseFloat(value) : null);
    const handleChangeConditionScore = value => handleChange('conditionScore', value);
    const handleChangeDateAndTime = value => handleChange('dateAndTime', value);
    const handleRemoveAssetCondition = () => removeItemWithConfirm(condition, 'asset condition', confirmOnRemoveFields, () => onRemove(conditionIndex));
    const selectedPercentageFailure = typeof percentFailure !== 'undefined' && percentFailure !== null ? percentFailure.toString() : '';
    const percentFailures = Array.from({
      length: 101
    }, (v, k) => ({
      id: k.toString(),
      name: k.toString()
    }));
    return /*#__PURE__*/React.createElement("section", {
      style: {
        marginTop: '20px'
      },
      className: "t-adci-".concat(conditionIndex)
    }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: 6
    }, /*#__PURE__*/React.createElement(DateTimePicker, {
      onChange: handleChangeDateAndTime,
      label: "Date / Time",
      defaultPicker: moment().format('x'),
      defaultValue: dateAndTime,
      timeFormat: "hh:mm A"
    })), /*#__PURE__*/React.createElement(Col, {
      sm: 3
    }, /*#__PURE__*/React.createElement(SinglePicker, {
      label: "Color and Gloss",
      labelKey: "name",
      onChange: handleChangeConditionAssetCoatingFinish,
      options: assetCoatingFinish.list,
      placeholder: "Select...",
      value: assetCoatingFinishID,
      returnValueKey: "id"
    })), /*#__PURE__*/React.createElement(Col, {
      sm: 3
    }, /*#__PURE__*/React.createElement("div", {
      className: "form-group"
    }, /*#__PURE__*/React.createElement(Label, {
      className: "control-label",
      htmlFor: "control-label"
    }, /*#__PURE__*/React.createElement("span", null, "\xA0")), /*#__PURE__*/React.createElement(Button, {
      size: "sm",
      onClick: handleRemoveAssetCondition,
      className: "float-md-right form-control t-adc-remove-condition tqc-control"
    }, /*#__PURE__*/React.createElement(Icon, {
      glyph: "trash"
    }), " Remove Condition")))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: 3
    }, /*#__PURE__*/React.createElement(SinglePicker, {
      label: "Adhesion",
      labelKey: "name",
      onChange: handleChangeAssetCoatingAdhesion,
      options: assetCoatingAdhesion.list,
      placeholder: "Select...",
      value: assetCoatingAdhesionID,
      returnValueKey: "id"
    })), /*#__PURE__*/React.createElement(Col, {
      sm: 3
    }, /*#__PURE__*/React.createElement(SinglePicker, {
      label: "% of Failure",
      labelKey: "name",
      onChange: handleChangePercentFailure,
      options: percentFailures,
      placeholder: "Select...",
      value: selectedPercentageFailure,
      returnValueKey: "id"
    })), /*#__PURE__*/React.createElement(Col, {
      sm: 3
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: "DFT",
      entity: "AssetCoatingCondition",
      field: "dft",
      value: dft,
      onChange: handleChangeDft
    })), /*#__PURE__*/React.createElement(Col, {
      sm: 3
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: "Condition Score",
      onChange: handleChangeConditionScore,
      entity: "AssetCoatingCondition",
      field: "conditionScore",
      value: conditionScore
    }))));
  }
}
AssetDetailsConditionItem.propTypes = {
  conditionIndex: PropTypes.number.isRequired,
  onRemove: PropTypes.func.isRequired,
  coatingDFTToleranceLow: PropTypes.number,
  coatingDFTToleranceHigh: PropTypes.number,
  coatingDFTFactorWithinLimits: PropTypes.number,
  coatingDFTFactorOutsideLimits: PropTypes.number,
  condition: PropTypes.shape({
    conditionScore: PropTypes.number,
    dft: PropTypes.number,
    assetCoatingAdhesionID: PropTypes.string,
    assetCoatingFinishID: PropTypes.string,
    dateAndTime: PropTypes.string,
    handleChangeConditionAssetCoatingFinish: PropTypes.string,
    percentFailure: PropTypes.number
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  assetCoatingFinish: PropTypes.shape({
    identifier: PropTypes.string,
    indexQuery: PropTypes.shape({}),
    list: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  assetCoatingFinishActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired,
  assetCoatingAdhesion: PropTypes.shape({
    identifier: PropTypes.string,
    indexQuery: PropTypes.shape({}),
    list: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  assetCoatingAdhesionActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired
};
AssetDetailsConditionItem.defaultProps = {
  coatingDFTFactorOutsideLimits: 1.5,
  coatingDFTFactorWithinLimits: 2,
  coatingDFTToleranceHigh: 20,
  coatingDFTToleranceLow: 10
};
export { AssetDetailsConditionItem as TestAssetDetailsConditionItem };
export default entityComposition(AssetDetailsConditionItem, ['assetCoatingFinish', 'assetCoatingAdhesion']);